import React from 'react';
import { useLocation } from 'react-router-dom';
import { APP_CONFIG } from '../../configs/config';
import { useAuth } from '../../contexts/AuthContext';
import Navigation from './Navigation';
import UserAvatar from './UserAvatar';

export default function Header() {
  const location = useLocation();
  const { user, isAuthenticated } = useAuth();

  const redirectToSignIn = () => {
    const returnUrl = encodeURIComponent(window.location.href);
    const signInUrl = `${APP_CONFIG.MAIN_WEBSITE_ORIGIN}/signin?returnUrl=${returnUrl}`;
    window.location.href = signInUrl;
  };

  const openMainProfile = () => {
    const profileUrl = `${APP_CONFIG.MAIN_WEBSITE_ORIGIN}/profile`;
    window.open(profileUrl, '_blank', 'noopener');
  };

  const openMainWebsite = () => {
    window.open(APP_CONFIG.MAIN_WEBSITE_ORIGIN, '_blank', 'noopener,noreferrer');
  };

  return (
    <header className="w-full bg-gray-900/95 backdrop-blur border-b border-gray-700/50 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 gap-4">
          {/* Logo - Left */}
          <div className="flex items-center flex-shrink-0">
            <button
              type="button"
              onClick={openMainWebsite}
              className="focus:outline-none focus:ring-2 focus:ring-violet-500 rounded-lg transition-opacity hover:opacity-80"
              aria-label="Go to TadReamk main website"
            >
              <img
                src={APP_CONFIG.LOGO_URL}
                alt="TadReamk"
                className="h-8 w-auto object-contain"
              />
            </button>
          </div>

          {/* Navigation - Center */}
          <Navigation currentPath={location.pathname} isMobile={false} />
          <Navigation currentPath={location.pathname} isMobile={true} />

          {/* Sign In / Avatar - Right */}
          <div className="flex items-center flex-shrink-0">
            {isAuthenticated && user ? (
              <UserAvatar user={user} onClick={openMainProfile} />
            ) : (
              <button
                type="button"
                onClick={redirectToSignIn}
                className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-500 hover:to-purple-500 text-white px-4 py-1.5 rounded-lg text-sm font-medium transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
              >
                Sign In
              </button>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}


